// extracted by mini-css-extract-plugin
export default {"footer":"PopupModal_footer__MkSsr"};